import React, { useCallback, useMemo, useRef } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { sortBy } from 'lib/array/arrayUtils'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { MONTHS } from 'constants/cruise'
import MonthTabButtonsGroup from 'components/OfferPage/TourV2/Departures/MonthTabs/MonthTabButtonsGroup'
import CruiseDepartureDatesTabItem from './CruiseDepartureDatesTabItem'

const Wrapper = styled.div`
  display: flex;

  ${mediaQueryUp.tablet} {
    margin-top: ${rem(16)};
  }
`

export const BodyTextSmall = styled.div`
  font-size: ${rem(8)};
  line-height: ${rem(16)};

  ${mediaQueryUp.tablet} {
    font-size: ${rem(12)};
  }
`

interface Props {
  departureDate: { [date: string]: Array<App.CruiseDepartureDetails> };
  tab: string;
  setTab: (value: string) => void;
  year: string;
  onClick?: () => void;
  cachedDepartures: { [cabinCategory: string]: App.CruisePriceDetails };
}

function CruiseDepartureDatesTabs({
  departureDate,
  setTab,
  tab,
  year,
  cachedDepartures,
}: Props) {
  const monthTabsRef = useRef<HTMLDivElement>(null)

  const availableMonths = useMemo(
    () => Object.keys(departureDate).filter((i) => i.includes(year)),
    [departureDate, year],
  )
  const onClick = useCallback((newTab: string) => setTab(newTab), [setTab])

  return (
    <Wrapper>
      {availableMonths.length > 1 && <MonthTabButtonsGroup ref={monthTabsRef}>
        {MONTHS.map((destination) => {
          const containsMonth = availableMonths.find(
            (i) => i.slice(5) === destination.id,
          )
          if (!containsMonth) {
            return
          }
          const validDepartures = departureDate[containsMonth].filter(departure => departure.lowestOverallPriceDetails)
          if (!validDepartures.length) {
            return
          }
          const monthlyDepartures = departureDate[containsMonth].length
          const departure = sortBy(
            validDepartures,
            (lowestPrice) => lowestPrice.lowestOverallPriceDetails.total,
            'asc',
          )[0]

          return (
            <CruiseDepartureDatesTabItem
              departure={departure}
              destination={destination}
              key={departure.id}
              isSelected={tab === containsMonth}
              onClick={() => onClick(containsMonth)}
              departuresAmount={monthlyDepartures}
              cachedDepartures={cachedDepartures}
            />
          )
        })}
      </MonthTabButtonsGroup>}
    </Wrapper>
  )
}

export default CruiseDepartureDatesTabs
